<template>
    <div>
        <lni-header-anonymous id="anonymousHeader" />
        <main>
            <div
                id="application-main"
                class="lni-o-layout--simple"
            >
                <span
                    id="lniMainContent"
                    tabindex="-1"
                />
                <router-view />
            </div>
        </main>
        <lni-footer
            id="footer"
        />
    </div>
</template>

<script>

/**
     * This is the root component for the application. Avoid making changes here, there is almost
     * always a better place to change.
     */

export default { name: 'ApplicationMain' }; </script>